module.exports = __webpack_public_path__ + "img/packing-1.0ac8b9c1.png";